<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th :colspan="3" class="grey lighten-1 font-weight-bold subtitle-1">
            {{ $t($route.meta.title) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- No -->
        <tr>
          <td class="width-3">
            <strong>問題No.</strong>
          </td>
          <td colspan="2">
            <span>{{ $route.query.no }}</span>
          </td>
        </tr>
        <!-- Proble Type -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("PROBLEM_TYPE") }}</strong>
          </td>
          <td colspan="2">
            <span>{{
              probleType.find((e) => e.key == item.type_value)
                ? probleType.find((e) => e.key == item.type_value).text
                : ""
            }}</span>
          </td>
        </tr>
        <!-- Directive -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("DIRECTIVE") }}</strong>
          </td>
          <td colspan="2">
            <span class="pre-wrap">{{ formGeneral.leadSentence }}</span>
          </td>
        </tr>
        <!-- Question -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("QUESTION") }}</strong>
          </td>
          <td colspan="2">
            <span v-text="nameConvert(item)" />
          </td>
        </tr>
        <!-- Illutration data-->
        <tr>
          <td class="width-3">
            <strong>{{ $t("ILLUSTRATION_DATA") }}</strong>
          </td>
          <td colspan="2" class="pa-2">
            <v-img
              max-height="280"
              height="200"
              max-width="270"
              v-if="formGeneral.image"
              :lazy-src="formGeneral.image.fileUrl"
              :src="formGeneral.image.fileUrl"
              aspect-ratio="1.7"
              contain
            />
          </td>
        </tr>
        <!-- Answer -->
        <tr>
          <td class="width-3" rowspan="2">
            <strong>{{ $t("ANSWER") }}</strong>
          </td>
          <td :class="checkAnswerCorrect(1) ? 'is--answers' : null">
            <span>{{ formGeneral.answers[0].value }}</span>
          </td>
          <td :class="checkAnswerCorrect(2) ? 'is--answers' : null">
            <span>{{ formGeneral.answers[1].value }}</span>
          </td>
        </tr>
        <tr>
          <td :class="checkAnswerCorrect(3) ? 'is--answers' : null">
            <span>{{ formGeneral.answers[2].value }}</span>
          </td>
          <td :class="checkAnswerCorrect(4) ? 'is--answers' : null">
            <span>{{ formGeneral.answers[3].value }}</span>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
export default {
  store: ["formGeneral"],
  props: ["probleType", "item", "isValue"],
  methods: {
    checkAnswerCorrect(value) {
      return Boolean(this.item.answer_correct.find((i) => i == value));
    },
    replaceText(name) {
      return name
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    nameConvert(item) {
      const { name } = item;
      if (name[0] && name[0][0]) {
        return this.replaceText(name[0][0]);
      } else if (name[0]) {
        return name[0][0];
      } else {
        return "";
      }
    },
  },
};
</script>
<style  scoped>
tr td {
  border: 1px solid #ccc;
  border-top: none;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff !important;
}
</style>